import type { FaireProductEntity } from "../../entity_types/product";

export const p_qzxbdy8twg: FaireProductEntity = {
  token: "p_qzxbdy8twg",
  type: "product",
  name: 'Classic Shade LED Bottle Stopper Light-5"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/0d0b3547356cb17d86db675d5e1f543b1d1bedc8865024e152e50faedaae8955.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82b1e137e3dc2e0c045c7255d34d7a68b02966a8c8f8c1b62e29435e6f6921e1.jpeg",
    "https://cdn.faire.com/fastly/db8db5e9b3469846170586d784896ba49e006563c4e4a18c3b71a92807727193.jpeg",
    "https://cdn.faire.com/fastly/c3c42c5bf9d3f644b0182933f5dcbb446dc6c1abf5d794a7526b2cc409850e9f.jpeg",
    "https://cdn.faire.com/fastly/c67b6e17b185b003c432f1e44558d300a2c1b5070205102413f6867660b3b8d1.jpeg",
    "https://cdn.faire.com/fastly/082c321e0b27e2279f8b0d06df6df562ead8162d7c7a0af3072ac4df3142efd9.jpeg",
    "https://cdn.faire.com/fastly/c655c4c80d99d17ddc1ca71c5cbea26d0a7b51a82e1b61fd6fab08affaf334bb.jpeg",
    "https://cdn.faire.com/fastly/0ddea6c027173ca9a754529a58bb5c7b39a3115d0c06a4ec4769cd6fb1487e17.jpeg",
    "https://cdn.faire.com/fastly/90f9efd9bbbdf8673f1bd9ab0fc7a5df22cc0ccefda526e99728537a4d5e5eea.jpeg",
    "https://cdn.faire.com/fastly/381e6b99fd11620e9ef6770c9672d321ce97e0dd4010436f336f75089824f765.jpeg",
    "https://cdn.faire.com/fastly/d062a5c0715354ada7381a9b1af14d3db8f91ccdf4f35eedebf2b1811dae5273.jpeg",
    "https://cdn.faire.com/fastly/cbe0f83a7682f638174ab6d0ce5e7d0872a9a442e4bab94579f4dff7992e1b91.jpeg",
    "https://cdn.faire.com/fastly/f936e977c915dce68b1557cfd10afbcab8db0891604fc0b98568109803606bb1.jpeg",
    "https://cdn.faire.com/fastly/388320a9638a66dd70f1d77b1303fd5aacd655d47e753f57adac80e3ab918848.jpeg",
    "https://cdn.faire.com/fastly/a6cd89aca6d0717c3afd84da19421e5a64a84512282fc8263f75ae4af6f40c6a.jpeg",
    "https://cdn.faire.com/fastly/dad88c3f6dbf1f3fe05fd33f979e721b37bb64107cf56c541e6f8f5253c18616.jpeg",
    "https://cdn.faire.com/fastly/f6fdd135f19b602c7b2054c8aec484d0162febf2a5b75385d60b4e732d78c068.jpeg",
    "https://cdn.faire.com/fastly/99c9fc9b1d6cf311c3acda2659db823e0dac8626f55f08ccefe2e8807906010b.jpeg",
    "https://cdn.faire.com/fastly/4a24db4f33e0a8c94f1f98b56c77e1d2125bca0510bf659dd917392a6aac37d9.jpeg",
    "https://cdn.faire.com/fastly/080f5432660eeb65e2da4ad167f4a8c4d0f2bcd47d60a0af8ec12bf1484ec913.jpeg",
    "https://cdn.faire.com/fastly/d07c7c6e8060313210420c0d8e6c4fd3768178768ef0c8653e5476a6c83bd3d2.jpeg",
  ],
  priceDollars: 40,
  description:
    "Create a warm and inviting atmosphere with our Classic Shade LED Bottle Stopper Light. This unique lamp transforms any empty bottle into an elegant lighting feature. The LED lights emit a soft and cozy glow, adding a touch of ambiance to your space. Measuring approximately 5 inches, it's a stylish and eco-friendly way to upcycle wine bottles and brighten your surroundings. Comes with a built-in USB-rechargeable battery and a run time of up to 16 hours. Dimmable with 3 light levels. Available in 8 colors options. Other LED Table Lights also available.",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:16.262Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
